/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
export function initVideoPlayer() {
    $(document).on('show.bs.modal', '#videoPlayer', function(e) {
		let videoId = $(e.relatedTarget).closest('[data-video-id]').data('videoId');
		let videoType = $(e.relatedTarget).closest('[data-video-type]').data('videoType') || '';
		let iframe = $(this).find('iframe');

		if (videoType === 'youku') {
			iframe.attr('allow', 'autoplay');
			iframe.attr('src', `https://player.youku.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0`);
		} else {
			iframe.attr('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
		}
    });

    $(document).on('hidden.bs.modal', '#videoPlayer', function(e) {
        let iframe = $(this).find('iframe');
        iframe.attr('src', '');
    });
}
